import { ref, unref, watch } from "vue";

export const useComputedAsRef = (watchable, func = value => value) => {
  const computed = ref(func(unref(watchable)));

  watch(watchable, value => {
    computed.value = func(value);
  });

  return computed;
};
